/**
 * useClinicOnboarding Hook - AWS API Version
 *
 * Checks if clinic has completed first upload.
 */

import { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';

export const useClinicOnboarding = () => {
  const [hasCompletedOnboarding, setHasCompletedOnboarding] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkOnboarding = useCallback(async () => {
    setLoading(true);
    try {
      const clinic = await api.getClinic();

      if (!clinic) {
        setHasCompletedOnboarding(false);
        setLoading(false);
        return;
      }

      setHasCompletedOnboarding(clinic.first_upload_at !== null);
    } catch (err) {
      console.error('Onboarding check error:', err);
      setHasCompletedOnboarding(false);
    }
    setLoading(false);
  }, []);

  const markOnboardingComplete = useCallback(async () => {
    try {
      await api.updateClinic({
        first_upload_at: new Date().toISOString(),
      });
      setHasCompletedOnboarding(true);
    } catch (err) {
      console.error('Failed to mark onboarding complete:', err);
    }
  }, []);

  useEffect(() => {
    checkOnboarding();
  }, [checkOnboarding]);

  return {
    hasCompletedOnboarding,
    loading,
    refetch: checkOnboarding,
    markOnboardingComplete,
  };
};
